import React from 'react';

import RouteListItem from './RouteListItem/RouteListItem';
import DestinationListItem from './DestinationListItem';
import BusStopListItem from './BusStopListItem/BusStopListItem';
import BusStopPredictionListItem from './BusStopPredictionListItem/BusStopPredictionListItem';
import { CTADataType } from '../../../../shared/utility';
import TrainStationListItem from './TrainStationListItem/TrainStationListItem';
import TrainStationPredictionListItem from './TrainStationPredictionListItem/TrainStationPredictionListItem';

const ListItem = (props) => {
    const { item, onClick, routeColor } = props;
    switch (item.type) {
        case CTADataType.ROUTE: {
            const { routeId, routeName, routeColor } = item;
            return <RouteListItem 
                number={routeId} 
                name={routeName}
                avatarBackgroundColor={routeColor} 
                onRouteClick={onClick} />;
        } 
        case CTADataType.DESTINATION: {
            const { destinationName } = item;
            return <DestinationListItem 
                    destination={destinationName} 
                    onDestinationClick={onClick} />;
        } 
        case CTADataType.BUS_STOP: {
            const { stopId, stopName } = item;
            return <BusStopListItem 
                id={stopId} 
                name={stopName} 
                onStopClick={onClick} 
                avatarBackgroundColor={routeColor}/>;
        } 
        case CTADataType.PREDICTION: {
            const {
                predictionTime, destination, route, vehicleId
            } = item;
            return <BusStopPredictionListItem 
                time={predictionTime}
                destination={destination}
                route={route}
                vehicle={vehicleId}
                avatarBackgroundColor={routeColor}/>;
        }
        case CTADataType.TRAIN_STATION: {
            const {
                stopId, stopName, destination, routeColor 
            } = item;
            return <TrainStationListItem 
                stopId={stopId}
                stopName={stopName}
                destination={destination}
                onStationClick={onClick} 
                avatarBackgroundColor={routeColor} />
        }
        case CTADataType.ARRIVAL: {
            const {
                predictionTime, destination, delay, route, stopId
            } = item;
            return <TrainStationPredictionListItem 
                stopId={stopId}
                time={predictionTime}
                destination={destination}
                isDelay={delay}
                route={route}
                avatarBackgroundColor={routeColor}/>
        }
        default: return null;
    }
};

export default ListItem;